import { Controller } from "@hotwired/stimulus";

// A note's whole page as a drop target for files (LI-316; see notes/show/component.html.haml).
// For an editor, whose page carries the Attachments uploader (the outlet), a drag of files over
// the page shows the "Drop to attach" overlay and a drop hands the files to that uploader's
// FilePond, so the size limit, progress and errors are the same as picking them. For a reader or
// guest there is no uploader: a drop is only stopped, so the browser doesn't open the file.
//
// Left alone: drops into Trix, which embeds files itself, and drops on the uploader's own strip,
// which FilePond already handles.
export default class extends Controller {
  static targets = ["overlay"];
  static outlets = ["note-attachment-uploader"];

  connect() {
    this.onDragOver = this.onDragOver.bind(this);
    this.onDragLeave = this.onDragLeave.bind(this);
    this.onDrop = this.onDrop.bind(this);
    window.addEventListener("dragover", this.onDragOver);
    window.addEventListener("dragleave", this.onDragLeave);
    window.addEventListener("drop", this.onDrop);
  }

  disconnect() {
    window.removeEventListener("dragover", this.onDragOver);
    window.removeEventListener("dragleave", this.onDragLeave);
    window.removeEventListener("drop", this.onDrop);
    this.toggleOverlay(false);
  }

  onDragOver(event) {
    if (!this.ours(event)) return this.toggleOverlay(false);

    event.preventDefault();
    event.dataTransfer.dropEffect = this.attachable ? "copy" : "none";
    this.toggleOverlay(this.attachable);
  }

  // Only leaving the window has no element to go to; moving between elements keeps the overlay.
  onDragLeave(event) {
    if (!event.relatedTarget) this.toggleOverlay(false);
  }

  onDrop(event) {
    this.toggleOverlay(false);
    if (!this.ours(event)) return;

    event.preventDefault();
    if (this.attachable) this.noteAttachmentUploaderOutlet.addFiles([...event.dataTransfer.files]);
  }

  ours(event) {
    const types = event.dataTransfer?.types || [];
    const target = event.target instanceof Element ? event.target : null;

    return Array.from(types).includes("Files") &&
      !target?.closest("trix-editor") && !target?.closest(".filepond--root");
  }

  get attachable() {
    return this.hasNoteAttachmentUploaderOutlet;
  }

  toggleOverlay(shown) {
    if (this.hasOverlayTarget) this.overlayTarget.hidden = !shown;
  }
}
